import { PageController } from '@client/components/_core/layout/PageController';
import { GovernanceCheckEdit } from '@client/components/mspr/governance-check-edit';
import { useTrpc } from '@client/hooks/api/useTrpc';
import { useOrgId } from '@client/hooks/business/org/useOrgId';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/mspr/service-providers/details/$id/manage/check/add')({
    staticData: {
        presentation: 'overlay',
        ui: { useParentTitle: true },
    },
    component: GovernanceCheckAddRoute,
});

function GovernanceCheckAddRoute() {
    const { id: providerId } = Route.useParams();
    const orgId = useOrgId();
    const navigate = useNavigate();
    const { trpcUtils } = useTrpc();

    return (
        <PageController route={Route}>
            <GovernanceCheckEdit
                action={['add', providerId]}
                onClose={async () => {
                    await trpcUtils.mspr.governanceCheck.invalidate();
                    navigate({
                        to: '/console/$orgId/mspr/service-providers/details/$id/manage',
                        params: { orgId, id: providerId },
                        fromComponent: 'drawer',
                    });
                }}
            />
        </PageController>
    );
}
